import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import * as moment from 'moment';
import { forkJoin } from 'rxjs';
import { UserService } from 'src/app/auth/service/user.service';
import { DateHelperService } from 'src/app/services/date-helper.service';
import { UserEatWellService } from 'src/app/services/user-eat-well.service';
import { UserTaskStatusService } from 'src/app/services/user-task-status.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-eat-well-tracker',
  templateUrl: './eat-well-tracker.component.html',
  styleUrls: ['./eat-well-tracker.component.scss'],
})
export class EatWellTrackerComponent implements OnInit {
  isLoading = false;
  userData: any;
  allEntries: any;
  eatWellWeekData: any;
  allTimeStats: any;
  allWeeksData: any = [];
  weekScore = 0;
  showBreakdown = false;
  userWeek = 0;
  showWeek = 0;
  allTaskStatuses:any;

  public currentWeek: Date[] = this.dateHelperService.getCurrentWeek();
  public today = this.dateHelperService.getToday();
  constructor(
    private dateHelperService: DateHelperService,
    private userService: UserService,
    private router: Router,
    private userEatWellService: UserEatWellService,
    private userTaskStatusService:UserTaskStatusService
  ) {}

  ngOnInit(): void {
    this.isLoading = true;
    this.userService.userData.subscribe((userData) => {
      if (userData) {
        this.userData = userData;
        this.isLoading = false;
      }
    });

    forkJoin({
      allEntries: this.userEatWellService.fetchAll(),
      allUserTaskStatuses: this.userTaskStatusService.fetchAll()
    }).subscribe(
      (responseData) => {
        this.allEntries = responseData.allEntries;

        this.eatWellWeekData = this.userEatWellService.generateWeekArray(
          this.currentWeek,
          this.allEntries
        );

        this.allTimeStats = this.userEatWellService.getStats(this.allEntries);

        this.allWeeksData.push(this.eatWellWeekData);
        let endOfWeek = this.currentWeek[6];
        let weeksRun = 0;
        this.userService.userData.subscribe((userData) => {
          if (userData) {
            while (moment(endOfWeek).subtract(1, 'week') > moment(this.userData.date_registered) && weeksRun<100) {
              weeksRun++;
              let prevWeek = this.dateHelperService.getWeekFor(
                moment(endOfWeek).subtract(1, 'week')
              );
              let prevWeekData = this.userEatWellService.generateWeekArray(
                prevWeek,
                this.allEntries
              );
              this.allWeeksData.push(prevWeekData);
              endOfWeek = prevWeek[6];
            }
            this.userWeek = this.allWeeksData.length;
            this.showWeek = this.allWeeksData.length;
          }
        });

        this.weekScore = this.userEatWellService.getWeekScore(
          this.allWeeksData[this.userWeek - this.showWeek]
        );
        this.allTaskStatuses = responseData.allUserTaskStatuses;
        let readResources = this.userTaskStatusService.checkTaskStatus(
          this.allTaskStatuses,
          'EatWellIntro'
        );
        if (!readResources) {
          this.router.navigate(['/modules', 'eat-well', 'resources']);
        }

        this.isLoading = false;
      },
      (error) => {}
    );
  }

  getDaysHit(weekData: any, foodType: string) {
    let daysHit = 0;
    weekData.forEach((day: any) => {
      if (foodType == 'fruit_veg') {
        if (day.fruit_veg >= 5) {
          daysHit++;
        }
      } else if (foodType == 'hydration') {
        if (day.hydration <= 3 && day.hasData) {
          daysHit++;
        }
      } else {
        if (day[foodType] >= 3) {
          daysHit++;
        }
      }
    });
    return daysHit;
  }


  getTotalDaysHitScore(weekData: any) {
    let score = 0;
    weekData.forEach((day: any) => {
      if (day.fruit_veg >= 5) {
        score++;
      }
      if (day.hydration <= 3 && day.hasData) {
        score++;
      }
      if (day.protein >= 3) {
        score++;
      }
      if (day.fat >= 3) {
        score++;
      }
      if (day.carbs >= 3) {
        score++;
      }
    });
    return score;
  }

  onPrevWeek(){

    if(this.showWeek>1){
      this.showWeek--;
      this.weekScore = this.userEatWellService.getWeekScore(
        this.allWeeksData[this.userWeek - this.showWeek]
      );
    }
    
  }

  onNextWeek(){
    if(this.showWeek<this.userWeek){
      this.showWeek++;
      this.weekScore = this.userEatWellService.getWeekScore(
        this.allWeeksData[this.userWeek - this.showWeek]
      );
    }
  }


  onDeleteEntry(entryId: number) {
    Swal.fire({
      title: "Are you sure?",
      text:  "You won't be able to undo this",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      cancelButtonText:'Cancel',
      confirmButtonText:'Yes, delete it',
    }).then((result) => {
      if (result.value) {
        this.userEatWellService.delete(entryId).subscribe(
          (responseData) => {
            Swal.fire("Your entry has been deleted", "success");

            let deleteIndex = -1;
            this.allEntries.forEach((entry:any, workoutIndex:any) => {
              if (+entry.user_eat_well_id === +entryId) {
                deleteIndex = workoutIndex;
              }
            });

            if (deleteIndex != -1) {
              // splice it
              this.allEntries.splice(deleteIndex, 1);
            }

            // redirect
            this.router.navigateByUrl('/nothing', { skipLocationChange: true }).then(() => {
              this.router.navigate(['/modules', 'eat-well', 'tracker']);
          })


          },
          (error) => {
            this.isLoading = false;
            Swal.fire('Error', 'An unknown error has occured, please contact us', 'error');
          }
        );
      }
    });
  }
}
